/* eslint-disable react-hooks/exhaustive-deps */
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridRowProps, GridRowsProp } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSelector } from "src/stateManagement/redux";
import { ActivitiesDetails } from "./components/details";
import './styles.scss'
import moment from "moment";
import { Box, IconButton, Typography } from "@mui/material";
import { tableStyles } from "src/shared/util/tableStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const TechnicalMeetDiscussions = () => {
    const { technicalMeetDiscussionsSorted } = useSelector((state) => state.location);
    const [data, setData] = useState<any>();
    const [activityType, setActivityType] = useState("");
    const [showDetails, setShowDetails] = useState(false);

    const [dataForTable, setDataForTable] = useState<any[]>([])

    useEffect(() => {
        setDataForTable(technicalMeetDiscussionsSorted)
    }, [technicalMeetDiscussionsSorted])


    const handleShowDetails = (data: any, discussedBy: any, discussedWith: string, executedDate: string) => {

        setData({
             variables: data,
             discussedBy,
             discussedWith,
             executedDate
         });
        setActivityType("Discusión Mesa Técnica");
        setShowDetails(true);
    };

    const columns: GridColDef[] = [
        {
            field: "executedDate",
            headerName: "Fecha",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "discussedBy",
            headerName: "Discutido por",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "discussedWith",
            headerName: "Discutido con",
            flex: 0.5,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "comments",
            headerName: "Comentario",
            headerAlign: "center",
            flex: 1,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            sx={{
                                width: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                lineHeight: "1.4",
                                py: "5px",
                                px: "2px",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                display: "-webkit-box",
                            }}
                        >
                            {params.row.comments}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "actions",
            headerAlign: "center",
            align: "center",
            headerName: "Opciones",
            flex: 0.2,
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => {
                return (
                    <IconButton
                        size="small"
                         onClick={() =>
                            handleShowDetails(
                                params.row.variables,
                                params.row.discussedBy,
                                params.row.discussedWith,
                                params.row.executedDate
                            )
                        }
                    >
                        <MoreVertIcon />
                    </IconButton>
                );
            },
        },
    ];

    const rows: GridRowsProp = dataForTable.map((item: any) => {
        return {
            id: item.id,
            fieldActivityId: item.id,
            executedDate: moment(item.executedDate).format("DD-MM-YYYY"),
            discussedBy: item.discussedBy,
            discussedWith: item.discussedWith,
            comments: item.comments,
            variables: item.variables,
        };
    });

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <Grid container spacing={0}>
            {showDetails ? (
                <ActivitiesDetails
                    setShowDetails={setShowDetails}
                    details={data}
                    activityType={activityType}
                />
            ) : (
                <Grid size={12}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            height: {
                                md: `calc(100vh - 375px)`,
                                lg: `calc(100vh - 375px)`,
                                xl: `calc(100vh - 383px)`,
                            },
                            ...tableStyles,
                        }}
                        getRowId={(row) => row.id}
                    />
                </Grid>
            )}
        
        </Grid>
    );
};
